import React from 'react';
import withAppState from '../../../mobx/withAppState'
import ApplyGratuity from '../../../components/ApplyGratuity';
import { Steps } from '../../../lib/constants'

const MiPayAtTableApplyGratuityWrapper = (props) => {
    const completeGratuity = () => {
        props.setGrandTotal();
        props.goToStep(Steps.PAY);
    }

    return <ApplyGratuity mainCTACallback={completeGratuity}/>
}

export default withAppState(MiPayAtTableApplyGratuityWrapper,
    {
        mobXActions: ({
            goToStep,
            setGrandTotal
        }) => ({
            goToStep,
            setGrandTotal
        })
    }
);